import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'
import theme from '../../../styles/theme'

const PILL_CONTAINER_HEIGHT = 18

const Container = styled(View)`
  justify-content: flex-start;
`

const WidgetContainer = styled(View)`
  margin-top: ${theme.gutterUnit / 4}px;
  margin-bottom: ${theme.gutterUnit / 4}px;
`

const PillContainer = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: ${PILL_CONTAINER_HEIGHT}px;
`

const ZeroContainer = styled(View)`
  position: absolute;
  flex-direction: row;
  justify-content: center;
  height: ${PILL_CONTAINER_HEIGHT}px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

const ZeroMarker = styled(View)`
  width: 2px;
  background-color: ${theme.colours.black};
  height: ${PILL_CONTAINER_HEIGHT}px;
`

const Pill = styled(View)`
  flex: 1;
  height: 8px;
  margin-left: 1px;
  margin-right: 1px;
  background-color: ${props => props.colour};
  border-radius: 2px;
`

const colourMap = {
  '-5': theme.colours.red,
  '-4': theme.colours.red,
  '-3': '#de4a1a',
  '-2': '#ed600f',
  '-1': '#fb7603',
  1: '#4ab2e0',
  2: '#47b4d1',
  3: '#42b6bd',
  4: '#3fb8ae',
  5: '#36bd87'
}

const getColour = (pill, value) => {
  const defaultColour = theme.colours.grey

  if (value > 0 && pill > 0) {
    if (value >= pill) {
      return colourMap[pill]
    }
  }

  if (value < 0 && pill < 0) {
    if (value <= pill) {
      return colourMap[pill]
    }
  }

  return defaultColour
}

export default class Impact extends PureComponent {
  render () {
    const { name, value } = this.props
    return (
      <Container>
        <Text size='s' center>{`${name} Impact`}</Text>
        <WidgetContainer>
          <PillContainer>
            {[-5, -4, -3, -2, -1, 1, 2, 3, 4, 5].map(pill => <Pill key={pill} colour={getColour(pill, value)} />)}
          </PillContainer>
          <ZeroContainer>
            <ZeroMarker />
          </ZeroContainer>
        </WidgetContainer>
      </Container>
    )
  }
}
